import axios from '@/helpers/axios'

export default {
  /**
   * 通过域名获取logo、title等运营商信息
   *
   * @param {object} params { domain: 'www.lcola.cn' }
   * @returns {Promise<object>} { id: 'id', name: 'name', title: 'title', logo: 'logo_uri', favicon_ico: 'favicon_ico_uri' }
   */
  getDetailByDomain(params) {
    return axios.get('/backend/service_providers/domain', { params: params })
  },
  /**
   * 通过ID获取运营商信息
   *
   * @param {object} id ''
   * @returns {Promise<object>} { id: 'id', name: 'name', title: 'title', logo: 'logo_uri', favicon_ico: 'favicon_ico_uri' }
   */
  getServiceProvider(id) {
    return axios.get('/backend/service_providers/' + id)
  }
}
